import { Component, Input, ChangeDetectorRef, OnChanges, SimpleChanges, AfterViewInit, OnDestroy } from '@angular/core';
import { ErrorLoggerService, NotificationService } from 'app/services';
import { TranslateService } from '@ngx-translate/core';
import { MapZonesService } from 'app/shared/components';
import { BaseComponent } from 'app/shared/components/base/base.component';
import { MediaSectionHandler } from '../../entities/shared/media.section';
import { MediaService } from 'app/services/media/media.service';


@Component({
    selector: 'key-admin-media',
    templateUrl: './media.component.html',
    styleUrls: ['./media.component.scss'],
    providers: [MapZonesService],
})
export class AdminMediaComponent extends BaseComponent implements OnChanges, OnDestroy, AfterViewInit {

    @Input() entity: any;
    @Input() handler: MediaSectionHandler;

    @Input() visible = false;

    errorMessage: string;
    
    asset: string;
    video: { url: string, filename: string, type: string };

    constructor(
        private error: ErrorLoggerService,
        private notify: NotificationService,
        public i18n: TranslateService,
        private ref: ChangeDetectorRef,
        private media: MediaService
    ) {
        super();
    }

    ngOnDestroy() {

    }


    ngAfterViewInit() {
    }

    ngOnChanges(_changes: SimpleChanges) {
        if (this.handler && this.visible) {
            this.load();
        }
    }

    async load(): Promise<void> {
        try {
            this.video = null;
            this.errorMessage = null;
            if (this.entity) {
                const data = await this.handler.mapEntityToEditor(this.entity);
                if (data.filename) {
                    this.asset = this.entity.asset.id;
                    this.video = {
                        type: 'video/mp4', // TODO: fix this
                        filename: data.filename,
                        url: this.media.getVideoUrl(this.asset, data.filename),
                    };
                    console.log('video', this.video);
                }
            } else {
                this.video = null;
            }
        } catch (err) {
            console.error(err);
            this.showError(this.i18n.instant('ADMIN.EDITORS.SHARED.CHART.ERRORS.UNEXPECTED_ERROR'));
        }
        this.ref.markForCheck();
    }

    showError(error: any) {
        this.error.trackException(error);
        this.errorMessage = error && this.notify.translateError(error);
        this.ref.markForCheck();

    }

}
